import React from "react";
import { Instagram, Mail, MapPin } from "lucide-react";
import { Logo } from "../assets";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const instagramLink =
    "https://www.instagram.com/scholarstoday.id?utm_source=ig_web_button_share_sheet&igsh=MWx6dXF2dTZyZTJtZA==";
  const emailAddress = "scholarstoday.id@gmail.com";
  const locationText =
    "Tegalsari, Tulungrejo, Kec. Pare, Kabupaten Kediri, Jawa Timur 64212, KEDIRI, Jawa Timur";

  return (
    <footer className="st-surface-cream px-6 py-12 sm:px-8 sm:py-14 lg:px-12 lg:py-16">
      <div className="mx-auto w-full max-w-6xl">
        <div className="grid gap-10 lg:grid-cols-[1.25fr_1fr] lg:gap-12">
          <div>
            <img src={Logo} alt="Scholars Today Logo" className="h-28 w-auto sm:h-32 lg:h-36" loading="lazy" />

            <p className="st-font-body st-footer-text mt-5 max-w-2xl text-[16px] leading-[1.35] sm:text-[18px]">
              ScholarsToday is a learning platform designed to help you boost your IELTS score with guidance from LPDP
              awardees, providing real insights, and proven strategies
            </p>

            <p className="st-font-body st-footer-text mt-6 text-[16px] leading-[1.3] sm:text-[18px]">
              Copyright © {currentYear} • Scholars Today All rights reserved
            </p>
          </div>

          <div className="lg:pt-1">
            <h3 className="st-font-body st-footer-title text-[34px] font-bold leading-none sm:text-[40px]">Catch Us!</h3>

            <ul className="mt-6 space-y-4">
              <li className="flex items-start gap-3">
                <span className="st-footer-icon-badge" aria-hidden="true">
                  <Mail size={20} strokeWidth={2.3} />
                </span>
                <a
                  href={`mailto:${emailAddress}`}
                  className="st-focus-ring st-font-body st-footer-link break-all pt-2 text-[16px] font-semibold leading-[1.2] sm:text-[18px]"
                >
                  {emailAddress}
                </a>
              </li>

              <li className="flex items-start gap-3">
                <span className="st-footer-icon-badge" aria-hidden="true">
                  <Instagram size={20} strokeWidth={2.3} />
                </span>
                <a
                  href={instagramLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="st-focus-ring st-font-body st-footer-link pt-2 text-[16px] font-semibold leading-[1.2] sm:text-[18px]"
                >
                  @scholarstoday.id
                </a>
              </li>

              <li className="flex items-start gap-3">
                <span className="st-footer-icon-badge" aria-hidden="true">
                  <MapPin size={20} strokeWidth={2.3} />
                </span>
                <p className="st-font-body st-footer-link max-w-[420px] pt-2 text-[16px] font-semibold leading-[1.25] sm:text-[18px]">
                  {locationText}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
